<template>
  <div class="hidden h-4 bg-white sm:block"></div>
</template>
